import React, { useState } from 'react';
import { LayoutDashboard, Newspaper, TrendingUp, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TickerSection from './TickerSection';
import HeroManager from './Manage/HeroManager'; // Ye aapka naya manager hai jo Edit/Add handle karega
import './Dashboard.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('Ticker');
  const navigate = useNavigate();

  const renderContent = () => {
    switch(activeTab) {
      case 'Ticker': return <TickerSection />;
      case 'Hero': return <HeroManager />; // Yahan ab Manager kaam karega
      case 'Trending': return <div>Trending Management Coming Soon...</div>;
      case 'Settings': return <div>Settings Management Coming Soon...</div>;
      default: return <TickerSection />;
    }
  };

  return (
    <div className="dash-container">
      <aside className="sidebar">
        <div className="sidebar-logo">APURDU ADMIN</div>
        <nav className="menu">
          <button onClick={() => setActiveTab('Ticker')} className={activeTab === 'Ticker' ? 'active' : ''}>
            <Newspaper/> <span>Ticker</span>
          </button>
          <button onClick={() => setActiveTab('Hero')} className={activeTab === 'Hero' ? 'active' : ''}>
            <LayoutDashboard/> <span>Hero</span>
          </button>
          <button onClick={() => setActiveTab('Trending')} className={activeTab === 'Trending' ? 'active' : ''}>
            <TrendingUp/> <span>Trending</span>
          </button>
          <button onClick={() => setActiveTab('Settings')} className={activeTab === 'Settings' ? 'active' : ''}>
            <Settings/> <span>Settings</span>
          </button>
        </nav>
        <button className="logout-btn" onClick={() => navigate('/login')}>
          <LogOut/> <span>Logout</span>
        </button>
      </aside>

      <main className="content-area">
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;